module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ky9uo"))).then(() => parcelRequire('5erN3'));